import React, { useCallback } from 'react';
import { AdminServiceEvents, ServicesContext } from '~/services';
import { defaultApiResponseHandler } from '~/util';
import { MaclType } from './useGetMacls';

export const useCreateMacl = (events: AdminServiceEvents) => {
    const services = React.useContext(ServicesContext);

    const createMacl = useCallback(
        async (name: string, files: DropzoneFileType[]) => {
            try {
                const data = new FormData();
                data.set(
                    'data',
                    JSON.stringify({
                        name,
                    })
                );
                if (files.length > 0) {
                    files.forEach((file, index) => data.append(`file${index + 1}`, file));
                }
                const result: ApiDataResponseType<MaclType> = await services.api.call({
                    method: 'post',
                    url: '/api/macls',
                    data,
                });

                // No response
                services.events.publish(events.macl_list_updated);

                return result.data;
            } catch (error) {
                throw defaultApiResponseHandler(error);
            }
        },
        [services.api, services.events, events.macl_list_updated]
    );

    return createMacl;
};
